<template>
	<section class="vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1">
		<div class="vx-col w-full md:w-5/6">
			<vx-card>
				<div class="flex mb-8">
					<router-link :to="`/campaign/donation-amount/${$route.params.slug_and_id}`">
						<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
					</router-link>
					<strong class="text-primary"><small>Pilih Metode Pembayaran</small></strong>
				</div>

				<!-- Payment gateway -->
				<payment-gateway 
					:paymentGateways="paymentGateways"
					@changeTypePayment="showPaymentGateway"
					@selected="selectPayment"
				>
          <template v-slot:content="{items}">
            <div 
                class="vx-col w-full rounded-lg mb-6"
                v-for="(item, i) in items"
                :key="i"
                style="border: 1px solid #ccc;cursor: pointer;"
            >
              <div class="vx-row py-4 px-2 items-center" @click.prevent="selectedPayment = item.id">
                <div class="vx-col w-1/4 md:w-1/6">
                  <img v-if="item.file === null" :src="`/assets/images/payment_method/${item.code}.png`" alt="" class="w-12 md:w-16 block text-left" />
                  <img v-else :src="item.file" alt="" class="w-12 md:w-16 block text-left" />
                </div>
                <div class="vx-col w-1/2 md:w-2/3">
                  <h5 class="text-left text-sm md:text-md lg:text-lg">
                    <strong>{{item.name}}</strong>
                  </h5>
                  <small v-if="item.code === 'saldo' && notEnoughBalance" class="mt-2">
                    Saldo anda tidak mencukupi
                  </small>
                </div>
                <div class="vx-col w-1/4 md:w-1/6 text-right">
                  <div v-if="item.code === 'saldo'">
                    <vs-button
                      v-if="notEnoughBalance"
                      type="border"
                      class="rounded-none p-2"
                      color="primary"
                      size="small"
                      @click.prevent="$router.push('/balance/checkout')"
                    >
                    Isi Saldo
                    </vs-button>
                    <div class="mx-auto" v-else>
                        <input type="radio" :value="item.id" v-model="selectedPayment" class="rad" />
                    </div>
                  </div>
                  <div class="mx-auto" v-else>
                      <input type="radio" :value="item.id" v-model="selectedPayment" class="rad" />
                  </div>
                </div>
              </div>
            </div>
          </template>
				</payment-gateway>
				<!-- / -->

				<!-- Detail product -->
				<table class="w-full px-4 mb-8">
					<tr class="mb-4">
						<td class="text-left">
							<strong class="text-grey">Campaign</strong>
						</td>
						<td class="text-right">
							<strong class="text-g">
								{{ campaign ? truncateString(campaign.name, 150) : '-' }}
							</strong>
						</td>
					</tr>
					<tr class="mb-4">
						<td class="text-left">
							<strong class="text-grey">Nominal</strong>
						</td>
						<td class="text-right">
							<strong>{{ formatRupiah(this.amount) }}</strong>
						</td>
					</tr>
					<tr class="mb-4">
						<td class="text-left">
							<strong class="text-grey">Total Pembayaran</strong>
						</td>
						<td class="text-right">
							<strong>{{ formatRupiah(this.amount) }}</strong>
						</td>
					</tr>
				</table>
				<!-- / -->

				<!-- Bayar -->
				<vs-button class="py-4 w-full px-8" @click.prevent="pay">
					<strong class="text-white">Bayar</strong>
				</vs-button>
				<!-- / -->
				
			</vx-card>
		</div>
	</section>
</template>
<script>
import { mapState } from 'vuex';
export default {
	components: {
		PaymentGateway: () => import('@/views/home/components/PaymentOption.vue')
	},
  data: () => ({
    selectedPayment: null,
    paymentGateways: [],
    transaction: {},
    amount: 0,
    balance: 50000,
		campaign: {}
  }),
  watch: {
  	amount(val) {
  		if(val != 0) {
  			this.amount = this.formatRupiah(val);
  		}
  	}
  },
  computed: {
    ...mapState('payment-gateway', ['va_payment_gateway', 'other_payment_gateway', 'saldo_payment_gateway']),
    ...mapState('campaign', ['transactionAmount']),
    notEnoughBalance() {
      const amount = this.replaceAll(this.amount.toString(), '.', '');
      if( this.balance < parseInt(amount) ) {
        return true;
      }

      return false;
    }
  },
  methods: {
    onSelectPayment(id) {
      this.selectedPayment = id;
    },
  	selectPayment(payment_id) {
  		this.selectedPayment = payment_id;
  	},
    pay () {
      if (this.selectedPayment === null) {
        this.$vs.notify({
          title: 'Harap Pilih Metode Pembayaran',
          text: '',
          color: 'warning',
          position: 'top-right'
        });

        return false;
      }

      const payment = this.paymentGateways.find(it => it.id === this.selectedPayment)

      if (!payment) {
        this.$vs.notify({
          title: 'Metode Pembayaran Tidak ditemukan',
          text: 'coba beberapa saat lagi',
          color: 'warning',
          position: 'top-right'
        })

        return false	
      }

      // Validate min transaction and max transaction
      const number = this.replaceAll(this.amount.toString(), '.', '');
      // if(parseInt(number) < payment.min_transaction) {
      // 	this.$vs.notify({
      //     title: `Minimal transaksi Rp ${this.formatRupiah(payment.min_transaction)}`,
      //     text: 'mohon ubah jumlah transaksi anda',
      //     color: 'warning',
      //     position: 'top-right'
      //   })

      //   return false
      // }

      if(parseInt(number) > payment.max_transaction) {
      	this.$vs.notify({
          title: `Maksimal transaksi Rp ${this.formatRupiah(payment.max_transaction)}`,
          text: 'mohon ubah jumlah transaksi anda',
          color: 'warning',
          position: 'top-right'
        });

        return false;
      }

      // Set new amount of donation
      this.$store.dispatch('campaign/setTransactionAmount', number);

      // Set selected payment method
      this.$store.dispatch('campaign/setTransactionPayment', payment);

      let nextLink = `/campaign/confirm/${this.$route.params.slug_and_id}`;
      if(this.$route.query.ref) {
        nextLink += `?ref=${this.$route.query.ref}`;
      }

      this.$router.push(nextLink);
    },
    showPaymentGateway (typePayment) {
    	if (typePayment === 'saldo') {
    		this.paymentGateways = this.saldo_payment_gateway.slice()	
    	}
      else if (typePayment === 'va') {
        this.paymentGateways = this.va_payment_gateway.slice()
      } else {
        this.paymentGateways = this.other_payment_gateway.slice()	
      }
    },
    getPaymentGateway () {
      this.$vs.loading()

      this.$store.dispatch('payment-gateway/getPaymentGateway', {is_enabled: 1})
        .then(() => {
          this.$vs.loading.close()
          this.paymentGateways = this.va_payment_gateway.slice()
        })
        .catch(e => {
          this.$vs.loading.close()
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    }
  },
  created () {
  	this.checkVerifyAccount();
    if( this.transactionAmount == 0 ) {
      this.$router.push(`/campaign/donation-amount/${this.$route.params.slug_and_id}`);
    }

    // get id from slug
		const arrSlug = this.$route.params.slug_and_id.split('-'),
				id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString();

  	this.$store.dispatch('campaign/getDetail', id)
    .then(campaign => {
      Object.assign(this.campaign, campaign);
    })
    .catch(e => console.error(e));
    this.getPaymentGateway();
    this.amount = this.transactionAmount;
  }
}
</script>
<style>
    .rad {
        position: relative;
        -webkit-appearance: none;
        appearance: none;
        background-color: #fff;
        font: inherit;
        width: 1rem;
        height: 1rem;
        border: 2px solid #FFCB05;
        border-radius: 50%;
    }
    .rad::before {
        content: '';
        border-radius: 50%;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em #045532;
        background: #045532;
    }
    .rad::after {
        content: '';
        opacity: 0;
        display: block;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        position: absolute;
        background: #045532;
    }
    .rad:checked {
        border: 2px solid #045532;
        transition: .1s ease-in;
        transform: scale(1.3);
    }
    .rad:checked::after {
        opacity: 1;
    }
</style>